import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

function Arrow() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 33 8">
      <path d="M32.354 4.354a.5.5 0 000-.708L29.172.464a.5.5 0 10-.707.708L31.293 4l-2.828 2.828a.5.5 0 10.707.708l3.182-3.182zM0 4.5h32v-1H0v1z" />
    </svg>
  );
}

const Button = styled.button`
  flex: 0 0 32px;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  margin: 0 0 0 18px;
  &[disabled] {
    opacity: 0.5;
  }
`;

export const ToRight = React.forwardRef(({ className }, ref) => (
  <Button className={className} ref={ref}>
    <Arrow />
  </Button>
));
ToRight.propTypes = {
  // eslint-disable-next-line react/require-default-props
  className: PropTypes.string,
};

export const ToLeft = styled(ToRight)`
  transform: scaleX(-1);
  margin: 0 18px 0 0;
`;
